exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clinic-show-user .modal-dialog{max-width:1340px}.clinic-show-user__signature{height:50px}", ""]);

// exports
